import { render, staticRenderFns } from "./MemberCredit.vue?vue&type=template&id=2ac22c5e"
import script from "./MemberCredit.vue?vue&type=script&lang=js"
export * from "./MemberCredit.vue?vue&type=script&lang=js"
import style0 from "./MemberCredit.vue?vue&type=style&index=0&id=2ac22c5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports